import { Icon } from './Icon';
import { safeHref } from '../lib/safeHref';

export interface Source {
  title: string;
  webViewLink: string;
  mimeType?: string;
}

function iconNameFor(webViewLink: string | undefined, mimeType?: string): string {
  if (webViewLink) {
    try {
      const u = new URL(webViewLink);
      if (u.hostname.includes('drive.google.com') || u.hostname.includes('docs.google.com')) return 'i-file';
      if (u.protocol === 'mailto:') return 'i-mail';
    } catch {
      /* fall through */
    }
  }
  if (mimeType) {
    if (mimeType.includes('document') || mimeType.includes('pdf')) return 'i-file';
    if (mimeType.includes('mail')) return 'i-mail';
  }
  return 'i-globe';
}

export function SourcesList({ sources }: { sources: Source[] }) {
  return (
    <div className="sources-block">
      <div className="sources-block__label">
        <Icon name="i-link" size={12} />
        Sources
      </div>
      <ul className="sources-block__list">
        {sources.map((s, i) => {
          const href = safeHref(s.webViewLink);
          const icon = (
            <Icon name={iconNameFor(href, s.mimeType)} size={16} className="sources-block__icon" />
          );
          return (
            <li key={i}>
              {href ? (
                <a href={href} target="_blank" rel="noopener noreferrer">
                  {icon}
                  <span className="sources-block__text">{s.title}</span>
                  <Icon name="i-open-external" size={14} className="sources-block__open" />
                </a>
              ) : (
                // Dropped the anchor — render the row title-only so the user
                // still sees the citation existed, just without a clickable
                // (and potentially unsafe) URL. Matches the visual layout of
                // the linked variant minus the trailing open-external icon.
                <span className="sources-block__nolink">
                  {icon}
                  <span className="sources-block__text">{s.title}</span>
                </span>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
